import { useEffect, useState } from 'react'
import { Field, Icon, Input, InputGroup } from '@chakra-ui/react'
import { useDebounce } from 'use-debounce'
import { IoSearch, IoClose } from 'react-icons/io5'
import { FormLabel } from '../Form/FormLabel'

export const InputSearch = ({
  onChange,
  defaultValue = '',
  value = '',
  placeholder = '',
  label,
  name = 'search',
  hideIcon = false,
  ...props
}) => {
  const [text, setText] = useState(defaultValue ? defaultValue : value)
  const [valueDebounce] = useDebounce(text, 700)

  useEffect(() => {
    if (value !== valueDebounce) {
      onChange(valueDebounce)
    }
  }, [valueDebounce])

  useEffect(() => {
    if (value !== text) {
      setText(value)
    }
  }, [value])

  return (
    <Field.Root>
      {label && <FormLabel name={name}>{label}</FormLabel>}
      <InputGroup
        width="100%"
        endElement={
          text ? (
            <IoClose size="20px" cursor="pointer" color="gray.600" onClick={() => setText('')} />
          ) : (
            !hideIcon && <Icon as={IoSearch} color="gray.300" />
          )
        }
      >
        <Input
          id={name}
          value={text || ''}
          onChange={(e) => {
            setText(e.target.value)
          }}
          placeholder={placeholder}
          {...props}
        />
      </InputGroup>
    </Field.Root>
  )
}
